export default __webpack_public_path__ + "static/media/footer_logo.d84a88e9.png";